import script from "./MenuHorizontal.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuHorizontal.vue?vue&type=script&setup=true&lang=js"

import "./MenuHorizontal.vue?vue&type=style&index=0&id=8d36f98e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d36f98e"]])

export default __exports__